import React from 'react';
import { motion } from 'framer-motion';

interface AnimationGesturesProps {
  children: React.ReactNode;
}

export const AnimationGestures: React.FC<AnimationGesturesProps> = ({
  children,
}) => {
  return (
    <motion.div
      className="w-full"
      whileHover={{ scale: 1 }}
      whileTap={{ scale: 0.9 }}
      transition={{ type: 'spring', stiffness: 400, damping: 10 }}
    >
      {children}
    </motion.div>
  );
};
